import { memo } from "react";
import { useTranslation } from "react-i18next";

import { Dialog, DialogContent, Typography } from "@mui/material";
import { Box, Button } from "../../common/components";
import { palette, spacing } from "../../styles/theme";
import { useThemeBreakpoints } from "../../utils/themeUtils";
import carbonNeutralImage from "../../assets/images/carbon-neutral-image.png";
import useExternalRoute from "../../utils/useExternalRoute";
import ThreeLeavesIcon from "../../common/components/Icon/ThreeLeavesIcon";

const CarbonNeutralModal = ({
  onClose,
  open,
}: {
  onClose: () => void;
  open: boolean;
}) => {
  const { t } = useTranslation();
  const { isMobile } = useThemeBreakpoints();
  const { TRANSLATED_EXTERNAL_ROUTE } = useExternalRoute();

  //disable the feature for now
  return null;

  // eslint-disable-next-line no-unreachable
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      maxWidth={"xs"}
      fullScreen={isMobile}
    >
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          gap={{ xs: spacing.groupingMobile, lg: spacing.groupingDesktop }}
        >
          <Box sx={{ borderRadius: "4px", height: 220 }}>
            <img
              src={carbonNeutralImage}
              alt="carbon neutral"
              style={{
                borderRadius: "4px",
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
          <Box
            display={"flex"}
            gap={"4px"}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <ThreeLeavesIcon color={palette.misc.green} />
            <Typography variant="title" textAlign={"center"}>
              {t("modal.carbon_neutral.title")}
            </Typography>
          </Box>
          <Typography variant="textRegular" textAlign={"center"}>
            {t("modal.carbon_neutral.description")}
          </Typography>
          <Box display={"flex"} gap={"12px"} justifyContent={"center"}>
            <Button
              variant="outlined"
              size={"small"}
              sx={{ fontSize: "16px" }}
              onClick={() => {
                window.open(TRANSLATED_EXTERNAL_ROUTE.SUSTAINABILITY, "_blank");
              }}
            >
              {t("general.learn_more")}
            </Button>
            <Button
              onClick={onClose}
              sx={{ fontSize: "16px" }}
              data-test="deleteModal.button"
              size={"small"}
            >
              <Typography variant="actionBoldBigIcon">
                {t("general.close")}
              </Typography>
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default memo(CarbonNeutralModal);
